import React from 'react';

const PrivacyPolicy = () => {
    const styles = {
        legalPage: {
            minHeight: '100vh',
            padding: '2rem 0',
            background: 'var(--body-color)'
        },
        legalContainer: {
            maxWidth: '800px',
            margin: '0 auto',
            background: 'white',
            padding: '3rem',
            borderRadius: '1rem',
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)'
        },
        h1: {
            fontSize: '2.5rem',
            color: 'var(--title-color)',
            marginBottom: '1rem',
            fontFamily: 'var(--title-font)'
        },
        legalUpdated: {
            color: 'var(--text-color)',
            fontSize: 'var(--small-font-size)',
            marginBottom: '2rem',
            opacity: 0.8
        },
        legalSection: {
            marginBottom: '2.5rem'
        },
        h2: {
            fontSize: '1.5rem',
            color: 'var(--title-color)',
            marginBottom: '1rem',
            position: 'relative',
            paddingLeft: '1rem'
        },
        p: {
            color: 'var(--text-color)',
            lineHeight: 1.8,
            marginBottom: '1rem'
        },
        ul: {
            listStyle: 'none',
            paddingLeft: '1.5rem'
        },
        li: {
            position: 'relative',
            paddingLeft: '1.5rem',
            marginBottom: '0.75rem',
            color: 'var(--text-color)',
            lineHeight: 1.6
        }
    };

    return (
        <div style={styles.legalPage}>
            <div style={styles.legalContainer} className="container">
                <h1>Privacy Policy</h1>
                <p className="legal-updated">Last updated: {new Date().toLocaleDateString()}</p>

                <section className="legal-section">
                    <h2>1. Information We Collect</h2>
                    <p>We collect information you provide directly to us, such as:</p>
                    <ul>
                        <li>Name and contact information</li>
                        <li>Business details and project requirements</li>
                        <li>Payment and billing information</li>
                        <li>Communications between us</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>2. How We Use Your Information</h2>
                    <p>We use the information we collect to:</p>
                    <ul>
                        <li>Provide, maintain, and improve our services</li>
                        <li>Process transactions and send related information</li>
                        <li>Send technical notices and support messages</li>
                        <li>Respond to your comments and questions</li>
                        <li>Analyze usage patterns to improve user experience</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>3. Information Sharing</h2>
                    <p>We do not sell, trade, or rent your personal information. We may share your information only in the following circumstances:</p>
                    <ul>
                        <li>With your consent</li>
                        <li>To comply with legal obligations</li>
                        <li>To protect our rights and safety</li>
                        <li>With service providers who assist our operations (e.g., payment processors)</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>4. Data Security</h2>
                    <p>We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.</p>
                </section>

                <section className="legal-section">
                    <h2>5. Your Rights</h2>
                    <p>You have the right to:</p>
                    <ul>
                        <li>Access your personal information</li>
                        <li>Correct inaccurate data</li>
                        <li>Request deletion of your data</li>
                        <li>Opt-out of marketing communications</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>6. Cookies and Analytics</h2>
                    <p>We use cookies and similar tracking technologies to track activity on our website and hold certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.</p>
                </section>

                <section className="legal-section">
                    <h2>7. Contact Us</h2>
                    <p>If you have questions about this Privacy Policy, please contact us at:</p>
                    <p>
                        Email: spinozadelva@gmail.com<br />
                        Phone: (917) 808-7320
                    </p>
                </section>
            </div>
        </div>
    );
};

export default PrivacyPolicy;